/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './confirm-modal.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/modal/confirm-modal/confirm-modal.component';
import * as i3 from '../../svg-icon/svg-icon.component.ngfactory';
import * as i4 from '../../../../../app/shared/svg-icon/svg-icon.component';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../app/shared/translations/translations.service';
const styles_ConfirmModalComponent:any[] = [i0.styles];
export const RenderType_ConfirmModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ConfirmModalComponent,data:{}});
function View_ConfirmModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'bold']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.bodyBold;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ConfirmModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'backdrop']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          29,'div',[['class','modal-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['class','modal-header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'h2',[['class','modal-title']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'button',[['class','close-button no-style icon-button'],
              ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ConfirmModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'svg-icon',[['name','close']],(null as any),(null as any),(null as any),
          i3.View_SvgIconComponent_0,i3.RenderType_SvgIconComponent)),i1.ɵdid(114688,
          (null as any),0,i4.SvgIconComponent,[i1.ElementRef,i1.Renderer2],{name:[0,
              'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','confirm-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ConfirmModalComponent_1)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','buttons right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'button',[['class','button cancel cancel-button'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.ConfirmModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'button',[['class','button primary submit-button'],['type','submit']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ConfirmModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.confirm()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i2.ConfirmModalComponent = _v.component;
        const currVal_1:any = 'close';
        _ck(_v,11,0,currVal_1);
        const currVal_3:any = _co.bodyBold;
        _ck(_v,20,0,currVal_3);
      },(_ck,_v) => {
        var _co:i2.ConfirmModalComponent = _v.component;
        const currVal_0:any = _co.title;
        _ck(_v,7,0,currVal_0);
        const currVal_2:any = _co.body;
        _ck(_v,17,0,currVal_2);
        const currVal_4:any = _co.cancel;
        _ck(_v,26,0,currVal_4);
        const currVal_5:any = _co.ok;
        _ck(_v,29,0,currVal_5);
      });
}
export function View_ConfirmModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'confirm-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_ConfirmModalComponent_0,
      RenderType_ConfirmModalComponent)),i1.ɵdid(49152,(null as any),0,i2.ConfirmModalComponent,
      [i1.ElementRef,i1.Renderer2,i6.Translations],(null as any),(null as any))],(null as any),
      (null as any));
}
export const ConfirmModalComponentNgFactory:i1.ComponentFactory<i2.ConfirmModalComponent> = i1.ɵccf('confirm-modal',
    i2.ConfirmModalComponent,View_ConfirmModalComponent_Host_0,{},{onShow:'onShow',
        onClose:'onClose',onDone:'onDone'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/modal/confirm-modal/confirm-modal.component.ngfactory.ts